var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DefaultMenu',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" Configuración del Sistema ")]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }